import { render, staticRenderFns } from "./UiTextbox.vue?vue&type=template&id=8031ccf8"
import script from "./UiTextbox.vue?vue&type=script&lang=js"
export * from "./UiTextbox.vue?vue&type=script&lang=js"
import style0 from "./UiTextbox.vue?vue&type=style&index=0&id=8031ccf8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports